export default __webpack_public_path__ + "static/media/list_02_img.3b06331e.png";